/**
 * Shared Framer Motion variants — Apple-style scroll reveals.
 * All animations: one-time, upward fade, restrained.
 */

/** Section-level fade up */
export const fadeUp = {
  hidden: {opacity: 0, y: 28},
  show: {
    opacity: 1,
    y: 0,
    transition: {duration: 0.6, ease: [0.4, 0, 0.2, 1]}
  }
};

/** Stagger container — wraps a grid/list of cards */
export const staggerCards = {
  hidden: {},
  show: {
    transition: {staggerChildren: 0.09, delayChildren: 0.04}
  }
};

/** Individual card/item variant (used inside staggerCards) */
export const cardItem = {
  hidden: {opacity: 0, y: 22},
  show: {
    opacity: 1,
    y: 0,
    transition: {duration: 0.5, ease: [0.4, 0, 0.2, 1]}
  }
};

/** Standard viewport config — triggers once when 8% visible */
export const vp = {once: true, amount: 0.08};
